import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ColorPickerEditor from 'common/components/ColorPicker';
import FontPickerEditor from 'common/components/FontPicker';

import {
    setFormFieldsQuestionFont,
    setFormFieldsQuestionFontSize,
    setFormFieldsQuestionColor,
} from 'common/entities/form/styleConfiguration/actions';
import {
    DEFAULT_FONT,
    DEFAULT_FONT_SIZE,
    DEFAULT_INPUT_LABEL_COLOR,
} from 'common/entities/form/styleConfiguration/defaultValues';
import { getDefaultStyle, styleShapePropTypes } from 'common/entities/form/styleConfiguration/utils';
import { getFormQuestionTextStyles } from 'common/entities/form/styleConfiguration/selectors';
import { getColors } from 'common/entities/color/selectors';
import { getFonts } from 'common/entities/font/selectors';
import { getFormId } from '../../../../selectors';

import { FORM_FIELDS_QA } from '../../../../utils/qaIdConstants';

const QuestionTextPanel = ({ formId, font, fontSize, color, colorList, fontList, ...props }) => (
    <React.Fragment>
        <FontPickerEditor
            fontFamilyList={fontList}
            defaultFontFamily={font}
            onChangeFontFamily={(id) => props.setFormFieldsQuestionFont(formId, id)}
            defaultFontSize={fontSize}
            onChangeFontSize={(size) => props.setFormFieldsQuestionFontSize(formId, size)}
            fontFamilyQa={`${FORM_FIELDS_QA}--fontFamily`}
            fontSizeQa={`${FORM_FIELDS_QA}--fontSize`}
        />
        <ColorPickerEditor
            colorList={colorList}
            firstColor={color}
            changeFirstColor={(id) => props.setFormFieldsQuestionColor(formId, id)}
            qaId={FORM_FIELDS_QA}
        />
    </React.Fragment>
);

QuestionTextPanel.propTypes = {
    color: styleShapePropTypes,
    font: styleShapePropTypes,
    fontSize: PropTypes.number,
    formId: PropTypes.string.isRequired,
    colorList: PropTypes.arrayOf(PropTypes.object).isRequired,
    fontList: PropTypes.arrayOf(PropTypes.object).isRequired,
    setFormFieldsQuestionFont: PropTypes.func.isRequired,
    setFormFieldsQuestionFontSize: PropTypes.func.isRequired,
    setFormFieldsQuestionColor: PropTypes.func.isRequired,
};

QuestionTextPanel.defaultProps = {
    color: getDefaultStyle(DEFAULT_INPUT_LABEL_COLOR),
    font: getDefaultStyle(DEFAULT_FONT),
    fontSize: DEFAULT_FONT_SIZE,
};

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const colorList = getColors(state);
    const fontList = getFonts(state);
    const { color, font, fontSize } = getFormQuestionTextStyles(state, formId);

    return {
        formId,
        color,
        font,
        fontSize,
        colorList,
        fontList,
    };
};

const mapDispatchToProps = {
    setFormFieldsQuestionFont,
    setFormFieldsQuestionFontSize,
    setFormFieldsQuestionColor,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionTextPanel);
